export class Role {

    public id: number;
    public name: string;
    public level: string;
    public description: string;
    public pivot: {
        id: number;
        role_id: number;
        user_id: number;
    }

    constructor(data: RoleInterface) {
        if (data) {
            this.loadInfo(data)
        }
    }

    loadInfo(data: RoleInterface): any {
        this.id = this.loadData(data.id)
        this.name = this.loadData(data.name)
        this.level = this.loadData(data.level)
        this.description = this.loadData(data.description)
    }

    private loadData<T>(data: T, defaul?: T) {
        return data === undefined ?
            defaul !== undefined ? defaul : null : data
    }
}

interface RoleInterface {
    id: number;
    name: string;
    level: string;
    description: string;
    pivot?: {
        id: number;
        role_id: number;
        user_id: number;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/role.model.ts